import { isShake } from './wanderMath';

export type GroomSample = { x: number; y: number; t: number };

export const GROOM_JOY_MS = 600;

/** Record one pointer sample. Mutates and returns `samples` so callers can feed `isShake`. */
export function appendGroomSample(
  samples: GroomSample[],
  x: number,
  y: number,
  t: number,
): GroomSample[] {
  samples.push({ x, y, t });
  return samples;
}

/** True when the hit is the actor or a descendant (compositor img), not merely the scene. */
export function isOverActor(hit: EventTarget | null, actor: Element | null): boolean {
  if (!(hit instanceof Element) || !actor) return false;
  return hit === actor || actor.contains(hit) || hit.closest('.habitat-scene-actor') === actor;
}

/** `overActor` is passed in so tests can drive `isShake` without jsdom `elementFromPoint`. */
export function shouldCompleteGroom(samples: GroomSample[], overActor: boolean): boolean {
  return overActor && isShake(samples);
}

/**
 * Back-and-forth trail that satisfies default `isShake`
 * (windowMs 400, minTravel 48, minReversals 2).
 */
export function shakeSampleTrail(x: number, y: number, t0 = 0): GroomSample[] {
  return [
    { x, y, t: t0 },
    { x: x + 30, y, t: t0 + 80 },
    { x, y, t: t0 + 160 },
    { x: x + 30, y, t: t0 + 240 },
  ];
}
